import React from 'react';
import { RefreshCw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const FilterPanel = ({
  showFilters,
  filterCategory,
  setFilterCategory,
  filterLocation,
  setFilterLocation,
  sortBy,
  setSortBy,
  availableCategories,
  availableLocations,
  resetFilters,
  styles,
  darkMode
}) => {
  return (
    <AnimatePresence>
        {showFilters && (
            <motion.div 
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                style={{ overflow: 'hidden', ...styles.filterContainer }}
            >
                <div style={styles.filterRow} className="no-scrollbar">
                    <div style={{ position: 'relative' }}>
                        <select 
                            value={filterCategory} 
                            onChange={(e) => setFilterCategory(e.target.value)}
                            style={styles.filterSelect}
                        >
                            <option value="">전체 카테고리</option>
                            {availableCategories.map(cat => (
                                <option key={cat.id || cat.value || cat.name} value={cat.value || cat.name}>
                                    {cat.label || cat.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    
                    <div style={{ position: 'relative' }}>
                        <select 
                            value={filterLocation} 
                            onChange={(e) => setFilterLocation(e.target.value)}
                            style={styles.filterSelect}
                        >
                            <option value="">전체 위치</option>
                            {availableLocations.map(loc => (
                                <option key={loc.id || loc.value || loc.name} value={loc.value || loc.name}>
                                    {loc.label || loc.name}
                                </option>
                            ))}
                        </select>
                    </div>
        
                    <select 
                        value={sortBy} 
                        onChange={(e) => setSortBy(e.target.value)}
                        style={styles.filterSelect}
                    >
                        <option value="newest">최신순</option>
                        <option value="oldest">오래된순</option>
                        <option value="name">가나다순</option>
                        <option value="location">위치순</option>
                        <option value="category">카테고리순</option>
                    </select>
        
                    <button onClick={resetFilters} style={styles.resetBtn}>
                        초기화
                    </button>
                </div>
                {(filterCategory || filterLocation) && (
                    <div style={styles.filterStatus}>
                        필터 적용 중: {filterCategory && `[${filterCategory}]`} {filterLocation && `[${filterLocation}]`}
                    </div>
                )}
            </motion.div>
        )}
    </AnimatePresence>
  );
};

export default FilterPanel;
